"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PXWidgetFacade_1 = require("./PXWidgetFacade");
class PXWidgetTestingFacade extends PXWidgetFacade_1.default {
    setStep(stepId) {
        this.eventContext.emit("testing set step", stepId);
    }
    triggerError() {
        this.eventContext.emit("testing trigger error");
    }
}
exports.default = PXWidgetTestingFacade;
